import { InjectionKey } from 'vue';

import { UseBottomSheet } from '../composables';

export const EmergencyBottomSheet: InjectionKey<UseBottomSheet> = Symbol();
export const EnableGeolocateBottomSheet: InjectionKey<UseBottomSheet> = Symbol();
